export default __webpack_public_path__ + "static/media/img-mobile-horse.37fb9465.png";